export default "__VITE_ASSET__DvSmZgNX__"